/**
 * Clears Bootstrap artifacts left behind by an appointment modal interrupted
 * by an Inquiry Summary refresh. This is intentionally scoped to that screen.
 */
export const cleanupOrphanedAppointmentModalArtifacts = (): void => {
  if (typeof document === "undefined" || document.querySelector(".modal.show")) {
    return;
  }

  document.querySelectorAll(".modal-backdrop").forEach(backdrop => {
    backdrop.remove();
  });

  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
};
